<template>
    <div>
        <!-- Modal -->
        <div id="quotaModal" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 40% !important;">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ current_quota ? 'Edit Quota' : 'New Quota' }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <b-button variant="primary" :variant="user_tab ? 'primary' : 'outline-primary'"
                                  @click="(user_tab = true, office_tab = false)">User Quota
                        </b-button>
                        <b-button :variant="office_tab ? 'primary' : 'outline-primary'"
                                  @click="(user_tab = false, office_tab = true),updateOfficeQuotas">Quota Breakdown
                        </b-button>
                        <hr>
                        <form @keydown="form.errors.clear($event.target.name)">

                            <div v-show="user_tab" id="user">
                                <div class="mb-2 mt-2">
                                    <label class="text-sm text-grey-darkest -mb-0"
                                           :class="{'text-red': form.errors.has('date')}">Month / Year</label>
                                    <datepicker v-model="form.date" :minimumView="'month'" :maximumView="'month'" :use-utc="true"
                                                format="MM / yyyy" @input="form.errors.clear('date')"
                                                :input-class="{'border-red' : form.errors.has('date'), 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control' : true}"></datepicker>
                                    <div class="text-red text-xs" v-if="form.errors.has('date')">{{
                                            form.errors.get('date')
                                        }}
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_count"
                                           :class="{'text-red': form.errors.has('proposal_count')}">Bid Count</label>
                                    <input v-model="form.proposal_count" type="number" name="proposal_count"
                                           id="proposal_count" @wheel="$event.target.blur()"
                                           class="rounded w-full p-1 text-grey-darkest text-sm form-control"
                                           :class="{'border-red': form.errors.has('proposal_count')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_count')">{{
                                            form.errors.get('proposal_count')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_volume"
                                           :class="{'text-red': form.errors.has('proposal_volume')}">Bid Volume
                                        ($)</label>
                                    <currency-input
                                        id="proposal_volume"
                                        v-model="form.proposal_volume"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('proposal_volume')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_volume')">{{
                                            form.errors.get('proposal_volume')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_gross_margin"
                                           :class="{'text-red': form.errors.has('proposal_gross_margin')}">Bid Gross
                                        Margin
                                        ($)</label>
                                    <currency-input
                                        id="proposal_gross_margin"
                                        v-model="form.proposal_gross_margin"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('proposal_gross_margin')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_gross_margin')">{{
                                            form.errors.get('proposal_gross_margin')
                                        }}
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <label class="text-sm text-grey-darkest -mb-0" for="contract_count"
                                           :class="{'text-red': form.errors.has('contract_count')}">Contract
                                        Count</label>
                                    <input v-model="form.contract_count" type="number" name="contract_count"
                                           id="contract_count" @wheel="$event.target.blur()"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                           :class="{'border-red': form.errors.has('contract_count')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_count')">{{
                                            form.errors.get('contract_count')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="contract_volume"
                                           :class="{'text-red': form.errors.has('contract_volume')}">Contract Volume
                                        ($)</label>
                                    <currency-input
                                        id="contract_volume"
                                        v-model="form.contract_volume"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('contract_volume')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_volume')">{{
                                            form.errors.get('contract_volume')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="contract_gross_margin"
                                           :class="{'text-red': form.errors.has('contract_gross_margin')}">Contract
                                        Gross Margin
                                        ($)</label>
                                    <currency-input
                                        id="contract_gross_margin"
                                        v-model="form.contract_gross_margin"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('contract_gross_margin')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_gross_margin')">{{
                                            form.errors.get('contract_gross_margin')
                                        }}
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <label class="text-sm text-grey-darkest -mb-0" for="sales_behavior_hours"
                                           :class="{'text-red': form.errors.has('sales_behavior_hours')}">Sales Behavior
                                        (Hrs)</label>
                                    <input v-model="form.sales_behavior_hours" type="number" name="sales_behavior_hours"
                                           id="sales_behavior_hours" @wheel="$event.target.blur()"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                           :class="{'border-red': form.errors.has('sales_behavior_hours')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('sales_behavior_hours')">{{
                                            form.errors.get('sales_behavior_hours')
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div v-show="office_tab" id="office">
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest" for="office_id">Select Office</label>
                                    <select name="office_id" id="office_id" v-model="form.office_id"
                                            class="text-grey-darkest text-sm form-control"
                                            :class="{'text-red': customErrors.office_id}"
                                            @change="customErrors.office_id=null, (form.office_id = checkOffice($event))">
                                        <option selected>Select Office</option>
                                        <option v-for="office in office_options" :value="office.id">{{ office.code }}</option>
                                    </select>

                                    <div class="text-red text-xs" v-if="customErrors.office_id">
                                        {{ customErrors.office_id }}
                                    </div>
                                </div>

                                <div class="mb-2 w-2/5">
                                    <label class="text-sm text-grey-darkest">Quota Percentage (%)
                                        <i class="fa fa-info-circle ml-2" aria-hidden="true"
                                           title="% entered will be calculated on the bid quota % & contract quota % set for the user under the user quota tab"></i>
                                    </label>
                                    <input type="number" name="office_quota_percentage" id="office_quota_percentage"
                                           min="0" max="100"
                                           v-model="form.office_percentage" placeholder="%"
                                           :disabled="office_selected_percentage"
                                           :class="{'text-red': customErrors.office_quota_percentage}"
                                           @wheel="$event.target.blur()"
                                           class="text-grey-darkest text-sm form-control"
                                           @input="(customErrors.office_quota_percentage = calculateOfficePercentage($event))"
                                           @keydown="customErrors.office_quota_percentage=null"/>

                                    <div class="text-red text-xs" v-if="customErrors.office_quota_percentage">
                                        {{ customErrors.office_quota_percentage }}
                                    </div>
                                </div>

                                <div class="mt-2 mb-2">
                                    <span v-if="selected_contract_types.length === 0" class="text-primary"
                                          style="cursor: pointer;" @click="addContractQuotaDiv('false')"><u>Set Contract Type % for the location</u></span>
                                </div>
                                <div class="ml-8" v-if="selected_contract_types.length > 0">
                                        <span v-for="(item,index) in selected_contract_types">
                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest" for="contract_type_id">Select Contract Type</label>
                                            <div class="d-flex w-full">
                                                <span class="" style="width: 90%;">
                                                <select name="contract_type_id" id="contract_type_id"
                                                        @change="(item.contract_type_id = checkContractType($event,item,index))"
                                                        v-model="item.contract_type_id"
                                                        class="text-grey-darkest text-sm form-control"
                                                        style="width: 100% !important; margin-right: 5px">
                                                <option selected>Select Contract Type</option>
                                                <option v-for="contractType in contractTypes" :value="contractType.id">{{
                                                        contractType.code
                                                    }}</option>
                                            </select>
                                            </span>
                                                <span class="">
                                                <b-button variant="danger" class="btn-sm ml-2"
                                                          @click.prevent="deleteContractTypeQuota(item,index)">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </b-button>
                                            </span>
                                            </div>

                                            <div class="text-red text-xs" v-if="item.contract_type_id_error">
                                                {{ item.contract_type_id_error }}
                                            </div>
                                        </div>

                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest"
                                                   for="contract_type_percentage">Quota Percentage (%)
                                                <i class="fa fa-info-circle ml-2" aria-hidden="true"
                                                   title="% entered will be calculated on the office quota % entered above"></i>
                                            </label>
                                            <input type="number" name="contract_type_percentage"
                                                   min="0" max="100"
                                                   id="contract_type_percentage"
                                                   @wheel="$event.target.blur()"
                                                   @input="(item.contract_type_percentage_error = calculateContractTypePercentage($event,item,index))"
                                                   v-model="item.percentage"
                                                   :class="{'text-red': item.contract_type_percentage_error}"
                                                   class="text-grey-darkest text-sm form-control w-2/5"/>

                                            <div class="text-red text-xs" v-if="item.contract_type_percentage_error">
                                                {{ item.contract_type_percentage_error }}
                                            </div>
                                        </div>
                                        </span>
                                </div>


                                <div class="ml-8 mt-2 mb-2">
                                    <span
                                        v-if="selected_contract_types.length > 0 && selected_contract_types.length !== contractTypes.length"
                                        class="text-primary" style="cursor: pointer;"
                                        @click="addContractQuotaDiv('true')"><u>Set % for another Contract Type</u></span>
                                </div>
                                <div class="mb-2">
                                    <b-button variant="primary" class="pull-right" @click.prevent="addOfficeQuota">Add
                                    </b-button>

                                </div>

                                <hr class="mt-12">
                                <div class="mt-2 table-responsive">
                                    <table class="text-black table table-striped">
                                        <thead>
                                        <th class="whitespace-no-wrap">OFFICE</th>
                                        <th class="whitespace-no-wrap">BID VOL</th>
                                        <th class="whitespace-no-wrap">CONTRACT VOL</th>
                                        <template v-for="contractType in contractTypes">
                                            <th class="whitespace-no-wrap">
                                                BID VOL ({{ contractType.code }})
                                            </th>
                                            <th class="whitespace-no-wrap">
                                                CONTRACT VOL ({{ contractType.code }})
                                            </th>

                                        </template>
                                        <th class="whitespace-no-wrap">SALES BEHAVIOR HOURS</th>
                                        <th class="whitespace-no-wrap">Action</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="item in form.office_quotas">
                                            <td :id="item.office_id" class="whitespace-no-wrap">{{
                                                    item.office_name
                                                }}
                                            </td>
                                            <td class="whitespace-no-wrap">
                                                {{ item.proposal_volume + '(' + item.percentage + '%)' }}
                                            </td>
                                            <td class="whitespace-no-wrap">
                                                {{ item.contract_volume + '(' + item.percentage + '%)' }}
                                            </td>
                                            <template v-for="contractType in contractTypes"
                                                      class="whitespace-no-wrap text-center">
                                                <template v-if="item.office_contract_type_quotas &&
                                                           item.office_contract_type_quotas.length > 0 &&
                                                           item.office_contract_type_quotas.find(x => x.contract_type_id === contractType.id)">

                                                    <template v-for="selectedContractType in item.office_contract_type_quotas">
                                                        <template v-if="selectedContractType.contract_type_id === contractType.id">
                                                            <td>
                                                                {{setBidVolume(item.proposal_volume, selectedContractType) }}
                                                            </td>
                                                            <td>
                                                                {{setContractVolume(item.contract_volume, selectedContractType) }}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template
                                                    v-if="!item.office_contract_type_quotas ||
                                                        item.office_contract_type_quotas.length === 0 ||
                                                        !item.office_contract_type_quotas.find(x => x.contract_type_id === contractType.id)">
                                                    <td>-</td>
                                                    <td>-</td>
                                                </template>
                                            </template>

                                            <td class="whitespace-no-wrap">{{ item.sales_behavior_hours }}</td>
                                            <td class="whitespace-no-wrap">
                                                <button @click.prevent="removeOfficeQuota(item.office_id)"
                                                        class="border-2 pull-right border-red focus:outline-none font-semibold
                                                           hover:bg-red
                                                           hover:no-underline
                                                           hover:text-white
                                                           material-icons p-1
                                                           rounded-full
                                                           text-base
                                                           text-red">
                                                    remove
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>

                                </div>

                            </div>
                        </form>


                    </div>
                    <div class="modal-footer" style="justify-content: space-between !important;">
                        <label for=""><input type="checkbox" v-model="remainderStatus">&nbsp;&nbsp;Apply to remainder of year</label>
                        <b-button variant="primary" @click.prevent="saved" :disabled="!issave">
                            Save
                            <i v-show="!issave" class="fa fa-1x fa-spinner fa-spin text-teal "></i>
                        </b-button>
                    </div>
                </div>

            </div>
        </div>

        <div class="text-2xl text-grey-darkest mb-4">{{ member.name }}'s Quotas</div>
        <div class="text-teal hover:text-teal-dark font-base text-sm mb-4 flex justify-between">
            <div @click="goBack" class="flex cursor-pointer">
                <span class="material-icons">chevron_left</span>
                <span>Back</span>
            </div>
            <div v-if="member.quotas.length > 0">
                <label for="include_in_company_report" class="text-grey-darkest mr-2">Include this user's quota in
                    company reports?</label>
                <input @change="updateIncludeInCompanyReports" type="checkbox" id="include_in_company_report"
                       name="include_in_company_report" :true-value="1" :false-value="0"
                       v-model="includeInCompanyReportsForm.include_in_company_report">
            </div>
        </div>

        <div v-if="member.quotas.length > 0" class="text-grey-darkest">
            <div class="text-right">
                <button data-toggle="modal" data-target="#quotaModal"
                        class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                    add
                </button>
            </div>

            <div class="bg-white shadow-md rounded mb-6 mt-2">
                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Month / Year
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Bid Count
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Bid Volume ($)
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Bid Gross Margin ($)
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Contract Count
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Contract Volume ($)
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Contract Gross Margin ($)
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Sales Behavior (Hrs)
                        </th>
                        <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr @click="editQuota(quota)" class="hover:bg-grey-lighter cursor-pointer"
                        v-for="quota in member.quotas">
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            {{ quota.date | formatDate }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            {{ quota.proposal_count }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            ${{ quota.proposal_volume }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            ${{ quota.proposal_gross_margin }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            {{ quota.contract_count }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            ${{ quota.contract_volume }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            ${{ quota.contract_gross_margin }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            {{ quota.sales_behavior_hours }}
                        </td>
                        <td class="px-4 py-2 border-b border-grey-light text-right">
                            <button @click.stop="editQuota(quota)"
                                    class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                edit
                            </button>
                            <button @click.stop="deleteQuota(quota)"
                                    class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                delete
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="/images/empty.svg">
                </div>
                <div class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't created a quota yet!</div>
                    </div>
                    <button @click="addQuota"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first quota!
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Form from "../../../utils/form";
import Datepicker from 'vuejs-datepicker';
import {CurrencyInput} from 'vue-currency-input'

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('MM / YYYY')
    }
});

export default {
    props: ['member', 'contractTypes', 'offices', 'currentTeamId', 'actionTeamId'],

    components: {Datepicker, CurrencyInput},

    data() {
        return {
            editing: false,
            current_quota: null,
            form: new Form({
                date: null,
                proposal_volume: null,
                contract_volume: null,
                proposal_gross_margin: null,
                contract_gross_margin: null,
                proposal_count: null,
                contract_count: null,
                sales_behavior_hours: '',
                office_quotas: [],
                office_id: null,
                office_percentage: null,
                contract_type_quotas: [],
                contract_type_id: null,
                contract_type_percentage: null,
                currentSelectedYear: new Date().getFullYear(),
            }),
            includeInCompanyReportsForm: new Form({
                include_in_company_report: this.member.include_in_company_report,
            }),
            customErrors: {
                'office_quota_percentage': null,
                'office_id': null,
                'contract_type_percentage': null,
                'contract_type_id': null,
            },
            remainderStatus: false,
            currentYear: new Date().getFullYear(),
            selectedMember:[],
            office_options:[],
            issave: true,
            user_tab: true,
            office_tab: false,
            selected_contract_types: [],
            contract_type_percentage_value: 0,
            office_selected_percentage: false,
        }
    },
    created() {
        this.setOfficeOptions();
    },

    mounted() {
        let self = this;
        $("#quotaModal").on('hidden.bs.modal', function () {
            self.form.reset();
            self.customErrors = {
                'office_quota_percentage': null,
                'office_id': null,
                'contract_type_percentage': null,
                'contract_type_id': null,
            };
            self.contract_type_percentage_value = 0;
            self.selected_contract_types = [];
            self.current_quota = null;
            self.editing = false;
        });
    },

    methods: {
        setOfficeOptions(){
            this.office_options = _.filter(this.offices, ['is_quota_office', 0]);
            if (this.office_options.length == 0 ){
                this.office_options = _.filter(this.offices, ['is_quota_office', 1]);
            }
            this.office_options = _.sortBy(this.office_options, ['code', 'load_order']);
        },
        goBack() {
            window.location = '/settings/teams/' + this.currentTeamId + '#/membership';
        },
        addContractQuotaDiv() {
            if (this.form.office_id && this.form.office_percentage) {
                let contractType = {
                    office_id: this.form.office_id,
                    contract_type_id: null,
                    percentage: null,
                    contract_type_name: null,
                    proposal_volume: null,
                    proposal_count: null,
                    proposal_gross_margin: null,
                    contract_volume: null,
                    contract_count: null,
                    contract_gross_margin: null,
                    sales_behavior_hours: null,
                    contract_type_id_error: null,
                    contract_type_percentage_error: null,
                }
                this.selected_contract_types.push(contractType)
            } else {
                if (!this.form.office_id) {
                    this.customErrors.office_id = 'Office is required'
                }
                if (!this.form.office_percentage) {
                    this.customErrors.office_quota_percentage = 'Valid Office quota percentage is required'
                }
            }

        },
        deleteContractTypeQuota(item, index) {
            if (index > -1) {
                this.selected_contract_types.splice(index, 1) && this.selected_contract_types;
            }
        },
        checkContractType(event, item, index) {
            let itemValue = parseInt(event.target.value);
            let arrayContractType = this.selected_contract_types.filter((value, key) =>
                value.contract_type_id === itemValue && key !== index
            );
            if (arrayContractType.length !== 0) {
                item.contract_type_id_error = "This contract type is already selected please select another contract type.";
                return null;
            } else {
                item.contract_type_id_error = null;
                return itemValue;
            }
        },
        checkOffice(event) {
            let itemValue = parseInt(event.target.value);
            let arrayOffice = this.form.office_quotas.filter((value, key) =>
                value.office_id === itemValue
            );
            let allOfficeOption = _.find(this.office_options, ['is_all_offices', 1]);
            let alreadyAddedAllOffices = this.form.office_quotas.filter((value, key) =>
                value.office_id === allOfficeOption.id
            );
            if (alreadyAddedAllOffices.length !== 0){
                if (this.form.office_quotas.length !== 0){
                    this.customErrors.office_id = "You have selected the “All Offices” filter. In order to select the specific office please delete the All Offices quota.";
                    return null;
                }
            }


            if (allOfficeOption && itemValue === allOfficeOption.id){
                if (this.form.office_quotas.length !== 0){
                    this.customErrors.office_id = "Please remove the added office first.";
                    this.form.office_id = null;
                    return null;
                }
                this.form.office_percentage = 100;
                this.office_selected_percentage = true;
            }else {
                this.form.office_percentage = '';
                this.office_selected_percentage = false;
            }

            if (arrayOffice.length !== 0) {
                this.customErrors.office_id = "This office is already selected please select another office.";
                return null;
            } else {
                this.customErrors.office_id = null;
                return itemValue;
            }
        },

        calculateContractTypePercentage(event, itemValue, index) {
            if (parseInt(event.target.value) > 100){
                return 'Contract type quota percentage should be less than or equal to 100';
            }
            let arrayContractTypes = this.selected_contract_types.filter((item, key) =>
                key !== index
            );
            let sum = arrayContractTypes.reduce((n, {percentage}) => parseInt(n) + parseInt(percentage), 0);

            if (sum > 0) {
                let contactTypePercentageError = parseInt(sum) + parseInt(event.target.value)
                if (contactTypePercentageError > 100) {
                    return 'Contract type quota percentage should be less than or equal to ' + (100 - parseInt(sum));
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },

        calculateOfficePercentage(event) {
            if (parseInt(event.target.value) > 100){
                return 'Office quota percentage should be less than or equal to 100';
            }
            let sum = this.form.office_quotas.reduce((n, {percentage}) => parseInt(n) + parseInt(percentage), 0);

            if (sum > 0) {
                let officePercentageError = parseInt(sum) + parseInt(event.target.value)
                if (officePercentageError > 100) {
                    return 'Office quota percentage should be less than or equal to ' + (100 - parseInt(sum));
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },

        saved() {
            this.issave = false
            this.updateOfficeQuotas()
            let self = this;
            if (self.form.date){
                self.form.date = moment(self.form.date).local().format();
            }
            self.form.currentSelectedYear = self.currentYear;
            if(self.selectedMember.length == 0) {

                self.selectedMember.push(self.member.id);
            }
            const payload = {
                member: JSON.stringify(self.selectedMember),
                remainderStatus: JSON.stringify(self.remainderStatus),
                teamId: this.actionTeamId
            };
            self.form.post(route('api.settings.team.member.quota.store.bulk', payload)).then((res) => {
                this.issave = true;
                this.user_tab = true;
                this.office_tab = false;
                $("#quotaModal").modal("hide");
                window.location = route('settings.member.quota.edit-user-quota', {team: this.actionTeamId, member: self.member.id});
            }).catch(error => {
                this.issave = true;
                this.user_tab = true;
                this.office_tab = false;
            });

            // if (self.editing) {
            //     self.form.put(route('api.settings.member.quota.update', {quota: self.current_quota.id})).then(() => {
            //         this.issave = true
            //         $("#quotaModal").modal("hide");
            //         window.location = route('settings.member.quota.edit', {member: self.member.id});
            //     }).catch(error => {
            //         this.issave = true
            //
            //     });
            // } else {
            //     self.form.post(route('api.settings.member.quota.store', {member: self.member.id})).then(() => {
            //         $("#quotaModal").modal("hide");
            //         this.issave = true
            //         window.location = route('settings.member.quota.edit', {member: self.member.id});
            //     }).catch(error => {
            //         this.issave = true
            //
            //     });
            // }
        },

        updateIncludeInCompanyReports() {
            let self = this;
            self.includeInCompanyReportsForm.put(route('api.settings.member.quota.updateIncludeInCompanyReports', {member: self.member.id})).then(({data}) => {
                window.location = route('settings.member.quota.edit', {member: self.member.id});
            });
        },

        addQuota() {
            $("#quotaModal").modal("show");
        },

        editQuota(quota) {
            $("#quotaModal").modal("show");
            this.current_quota = quota;
            this.user_tab = true;
            this.office_tab = false;
            this.editing = true;
            Object.assign(this.form, {
                date: moment(quota.date).format(),
                proposal_volume: quota.proposal_volume ? Number(quota.proposal_volume.split(',').join('')) : null,
                contract_volume: quota.contract_volume ? Number(quota.contract_volume.split(',').join('')) : null,
                proposal_gross_margin: quota.proposal_gross_margin ? Number(quota.proposal_gross_margin.split(',').join('')) : null,
                contract_gross_margin: quota.contract_gross_margin ? Number(quota.contract_gross_margin.split(',').join('')) : null,
                proposal_count: quota.proposal_count,
                contract_count: quota.contract_count,
                sales_behavior_hours: quota.sales_behavior_hours,
                office_quotas: quota.office_quotas,
                contract_type_quotas: quota.contract_type_quotas,
            });
        },

        deleteQuota(quota) {
            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this quota!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: false,
                closeOnCancel: true,
            }).then((result) => {
                if (result.value) {
                    self.form.delete(route('api.settings.member.quota.destroy', {quota: quota.id})).then(() => {
                        Swal.fire({
                            title: "Quota deleted!",
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'Ok!',
                            closeOnConfirm: false,
                        }).then(() => {
                            window.location = route('settings.member.quota.edit', {member: self.member.id});
                        });
                    });
                }
            });
        },

        addOfficeQuota() {
            let self = this;
            if (self.form.office_id && self.form.office_percentage) {
                if (self.form.office_percentage > 100) {
                    self.customErrors.office_quota_percentage = 'Office quota percentage should be less than or equal to 100'
                } else {
                    self.office_selected_percentage = false;
                    if (!self.form.office_quotas.find(x => x.office_id == self.form.office_id)) {
                        self.form.office_quotas.push({
                            office_id: self.form.office_id,
                            office_name: self.offices.find(x => x.id == self.form.office_id).code,
                            percentage: self.form.office_percentage,
                            proposal_volume: ((self.form.proposal_volume * self.form.office_percentage) / 100).toFixed(2),
                            proposal_count: ((self.form.proposal_count * self.form.office_percentage) / 100).toFixed(2),
                            proposal_gross_margin: ((self.form.proposal_gross_margin * self.form.office_percentage) / 100).toFixed(2),
                            contract_volume: ((self.form.contract_volume * self.form.office_percentage) / 100).toFixed(2),
                            contract_count: ((self.form.contract_count * self.form.office_percentage) / 100).toFixed(2),
                            contract_gross_margin: ((self.form.contract_gross_margin * self.form.office_percentage) / 100).toFixed(2),
                            sales_behavior_hours: ((self.form.sales_behavior_hours * self.form.office_percentage) / 100).toFixed(2),
                            office_contract_type_quotas: self.selected_contract_types,
                        })

                        self.form.office_quotas.map(quota => {
                            return Object.assign(quota, {
                                'office_contract_type_quotas': self.updateContractTypeQuotas(quota.office_contract_type_quotas, quota),
                            })
                        })
                        self.form.office_id = null
                        self.form.office_percentage = null
                        self.contract_type_percentage_value = 0;
                        self.selected_contract_types = [];
                    } else {
                        self.customErrors.office_id = 'Select some other office'
                    }
                }
            } else {
                if (!self.form.office_id) {
                    self.customErrors.office_id = 'Office is required'
                }
                if (!self.form.office_percentage) {
                    self.customErrors.office_quota_percentage = 'Valid Office quota percentage is required'
                }
            }
        },
        setBidVolume(proposal_volume, selectedType) {
            return selectedType.proposal_volume + '(' + selectedType.percentage + '%)'
        },
        setContractVolume(contract_volume, selectedType) {
            return selectedType.contract_volume + '(' + selectedType.percentage + '%)';
        },
        removeOfficeQuota(officeId) {
            this.office_selected_percentage = false;
            this.form.office_quotas = this.form.office_quotas.filter(function (obj) {
                return obj.office_id !== officeId;
            });
        },

        // addContractQuota() {
        //     if (this.form.contract_type_id && this.form.contract_type_percentage) {
        //
        //         if (this.form.contract_type_percentage > 100) {
        //             this.customErrors.contract_type_percentage = 'Contract type quota percentage should be less than or equal to 100'
        //         } else {
        //             if (!this.form.contract_type_quotas.find(x => x.contract_type_id == this.form.contract_type_id)) {
        //                 this.form.contract_type_quotas.push({
        //                     contract_type_id: this.form.contract_type_id,
        //                     contract_type_name: this.contractTypes.find(x => x.id == this.form.contract_type_id).code,
        //                     percentage: this.form.contract_type_percentage,
        //                     proposal_volume: (this.form.proposal_volume * this.form.contract_type_percentage) / 100,
        //                     proposal_count: (this.form.proposal_volume * this.form.contract_type_percentage) / 100,
        //                     proposal_gross_margin: (this.form.proposal_gross_margin * this.form.contract_type_percentage) / 100,
        //                     contract_volume: (this.form.contract_volume * this.form.contract_type_percentage) / 100,
        //                     contract_count: (this.form.contract_volume * this.form.contract_type_percentage) / 100,
        //                     contract_gross_margin: (this.form.contract_gross_margin * this.form.contract_type_percentage) / 100,
        //                     sales_behavior_hours: (this.form.sales_behavior_hours * this.form.contract_type_percentage) / 100,
        //                 })
        //
        //                 this.form.contract_type_id = null
        //                 this.form.contract_type_percentage = null
        //             } else {
        //                 this.customErrors.contract_type_id = 'Select some other contract type'
        //             }
        //         }
        //     } else {
        //         if (!this.form.contract_type_id) {
        //             this.customErrors.contract_type_id = 'Contract type is required'
        //         }
        //         if (!this.form.contract_type_percentage) {
        //             this.customErrors.contract_type_percentage = 'Valid Contract type quota percentage is required'
        //         }
        //     }
        // },
        // removeContractQuota(contractTypeId) {
        //     this.form.contract_type_quotas = this.form.contract_type_quotas.filter(function (obj) {
        //         return obj.contract_type_id !== contractTypeId;
        //     });
        // },

        updateOfficeQuotas() {
            this.form.office_quotas = this.form.office_quotas.map(quota => {
                return {
                    office_id: quota.office_id,
                    office_name: this.offices.find(x => x.id === quota.office_id).code,
                    percentage: quota.percentage,
                    proposal_volume: ((this.form.proposal_volume * quota.percentage) / 100).toFixed(2),
                    proposal_count: ((this.form.proposal_count * quota.percentage) / 100).toFixed(2),
                    proposal_gross_margin: ((this.form.proposal_gross_margin * quota.percentage) / 100).toFixed(2),
                    contract_volume: ((this.form.contract_volume * quota.percentage) / 100).toFixed(2),
                    contract_count: ((this.form.contract_count * quota.percentage) / 100).toFixed(2),
                    contract_gross_margin: ((this.form.contract_gross_margin * quota.percentage) / 100).toFixed(2),
                    sales_behavior_hours: ((this.form.sales_behavior_hours * quota.percentage) / 100).toFixed(2),
                    office_contract_type_quotas: quota.office_contract_type_quotas,
                }
            })

            this.form.office_quotas.map(quota => {
               return Object.assign(quota, {
                    'office_contract_type_quotas': this.updateContractTypeQuotas(quota.office_contract_type_quotas, quota),
                })
            })
        },

        updateContractTypeQuotas(contractTypeQuotas, quotaOffice) {
            return contractTypeQuotas.map(quota => {
                return {
                    office_id: quota.office_id,
                    contract_type_id: quota.contract_type_id,
                    contract_type_name: this.contractTypes.find(x => x.id === quota.contract_type_id).code,
                    percentage: quota.percentage,
                    proposal_volume: ((quotaOffice.proposal_volume * quota.percentage) / 100).toFixed(2),
                    proposal_count: ((quotaOffice.proposal_count * quota.percentage) / 100).toFixed(2),
                    proposal_gross_margin: ((quotaOffice.proposal_gross_margin * quota.percentage) / 100).toFixed(2),
                    contract_volume: ((quotaOffice.contract_volume * quota.percentage) / 100).toFixed(2),
                    contract_count: ((quotaOffice.contract_count * quota.percentage) / 100).toFixed(2),
                    contract_gross_margin: ((quotaOffice.contract_gross_margin * quota.percentage) / 100).toFixed(2),
                    sales_behavior_hours: ((quotaOffice.sales_behavior_hours * quota.percentage) / 100).toFixed(2),
                }
            })
        }

    }
}
</script>

<style scoped>
.table thead th {
    vertical-align: baseline;
}
</style>
